import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.bereich-kopfdaten-aktualisieren';
import * as api from '../../../clients/displaysteuerung';

@Injectable()
export class DisplaysteuerungBereichKopfdatenAktualisierenEffects {

    BereichKopfdatenAktualisieren$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_BEREICH_KOPFDATEN_AKTUALISIEREN),
        mergeMap((x: ac.PostBereichKopfdatenAktualisierenAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postBereichKopfdatenAktualisieren(x.bereichKopfdatenRequest).pipe(
                map((result: any) => {
                    return new ac.PostBereichKopfdatenAktualisierenErfolgreichAction(result, x.bereichKopfdatenRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostBereichKopfdatenAktualisierenFehlerAction(error, x.bereichKopfdatenRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.VerwaltenCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.VerwaltenCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.VerwaltenCommandService);
        }
        return this.service;
    }
}
